<template>
  <Popup style="background-color: rgba(0, 0, 0, 0);" v-model:show="show">
    <div class="p-box">
      <div class="p-box__card">
        <div class="p-box__hint"></div>
        <div class="p-box__title">提示</div>
        <div class="p-box__content">
          已支付成功，请刷新页面查看
        </div>
        <div class="p-box__button" @click="reload">
          刷新页面
        </div>
      </div>
    </div>
  </Popup>
</template>
<script setup>
import { Popup } from 'vant';
import { ref } from "vue";
const show = ref(false)
const close = () => {
  show.value = false
}
const open = () => {
  show.value = true
}
const reload = () => {
  location.reload()
}
// eslint-disable-next-line no-undef
defineExpose({
  close,
  open
})
</script>
<style scoped>
.p-box__card {
  padding: 40px;
  font-size: 24px;
  line-height: 36px;
  color: #A2A3A4;
  border-radius: 8px;
  width: 590px;
  background-color: #171A1B;
  position: relative;
  overflow: hidden;
}

.p-box__card>* {
  position: relative;
  z-index: 2;
}

.p-box__title {
  font-size: 32px;
  color: #FFFFFF;
  opacity: 0.9;
  text-align: center;
  margin-bottom: 10px;
}

.p-box__hint {
  width: 80px;
  height: 80px;
  margin: 20px auto 50px;
  background: url('@/static/image/hint.png') center / 100% no-repeat;
}

.p-box__content {
  overflow: auto;
  max-height: 60vh;
  text-align: center;
}

.p-box__content div {
  min-height: 24px;
}

.p-box__button {
  font-size: 32px;
  color: #fff;
  text-align: center;
  background: #00CAB7;
  border-radius: 8px;
  height: 80px;
  line-height: 80px;
  font-weight: normal;
  margin-top: 56px;
}
</style>